import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import IWorkflowEngine from "@/interfaces/workflow-engine.interfaces";
import workflowService from "@/services/workflow.service";
import { PaginatedResponse, RequestsBaseReturn } from "@/types/requests.types";

export type UseGetWorkflowEngineBackofficeReturn =
  RequestsBaseReturn<PaginatedResponse<IWorkflowEngine> | null>;

const useGetWorkflowEngineBackoffice = (): UseGetWorkflowEngineBackofficeReturn => {
  const {
    data = null,
    isValidating: isLoading,
    error,
  } = useSWR<PaginatedResponse<IWorkflowEngine>, Error>(
    SWR_KEYS.getWorkflowEngineBackoffice,
    () => workflowService.getAllWorkflowEngineBackofficeAll(),
    {
      revalidateOnFocus: false,
    }
  );

  return { data, isLoading, error };
};

export default useGetWorkflowEngineBackoffice;
